import { useEffect } from "react";

import { acquirePullRequestEnvironmentConnections } from "../../environments/runtime";

export function usePullRequestSavedEnvironmentConnections(): void {
  useEffect(() => {
    let disposed = false;
    let release: (() => void) | null = null;

    void acquirePullRequestEnvironmentConnections().then((nextRelease) => {
      release = nextRelease;
      if (disposed) {
        nextRelease();
      }
    });

    return () => {
      disposed = true;
      release?.();
    };
  }, []);
}
